// extracted by mini-css-extract-plugin
module.exports = {"container":"Prameters_container__1Pl3_"};